import { render } from "./Tile.vue?vue&type=template&id=b09e5b2a&scoped=true&ts=true"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"

import "./Tile.vue?vue&type=style&index=0&id=b09e5b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b09e5b2a"]])

export default __exports__